import React from "react";

import Box from "@mui/material/Box";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  value: number;
  currentValue: number;
}

export const OrderWindow = (props: TabPanelProps) => {
  const { children, currentValue, value, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={currentValue !== value}
      id={`order-window-tabpanel-${value}`}
      aria-labelledby={`order-window-tab-${value}`}
      style={{ height: "100%" }}
      {...other}
    >
      {currentValue === value && <Box style={{ height: "100%" }}>{children}</Box>}
    </div>
  );
};
